module.exports = __webpack_public_path__ + "static/img/beatTheBox.f279d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameImg/beatTheBox.png
// module id = 2TGj
// module chunks = 1